module.exports = __webpack_public_path__ + "static/headphones-lady-tablet-de67e5a3ff1b91280155ede839387c8e.jpg";